import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/core/authentication/services/auth.service';
import { SiteSettingsService } from "app/site-settings/services/site-settings.service";
import { Error } from 'app/core/error-handler/models';
import { DefaultLanguageStringsService } from 'app/core/language/services/default-language-strings.service';
import { LanguageService } from 'app/core/language/services/language.service';
import { UserInterface } from 'app/core/user/models';
import { ErrorSSOSingleInterface } from "app/site-settings/models/error-message";
import { PrivacyPolicyComponent } from 'app/login/components/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from 'app/login/components/terms-of-use/terms-of-use.component';
import { GlobalConstants } from 'app/shared/constants/globalconstants';
import { SiteLogoService } from 'app/site-logo/services/site-logo.service';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { skip, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: "cz-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SSOLandingPageErrorComponent implements OnInit, OnDestroy {
  public displayErrorContent: boolean = true;
  public languageLoaded: boolean = false;
  public msgNum: number = 1;
  public authError$: Observable<Error>;
  public errorMessage: ErrorSSOSingleInterface;
  public errorSSOMessage$: BehaviorSubject<ErrorSSOSingleInterface>;
  public readonly language$: BehaviorSubject<{ [key: string]: string }>;

  // languageArray variable declaration
  public languageArray: any;
  public logoHref: string;
  public selectedLanguage: string;
  private readonly _cookieName: string = "Allow-Cookies";
  // _cookieName is moved to localstoorage for cookies
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _authService: AuthService,
    public dialog: MatDialog,
    private readonly _cookieService: CookieService,
    private readonly _translate: TranslateService,
    private readonly _languageService: LanguageService,
    private readonly _siteLogoService: SiteLogoService,
    private readonly _siteSettingsService: SiteSettingsService,
    public readonly sanitizer: DomSanitizer,
    // private readonly  _localStorage: WindowLocalStorage,
    public _GlobalConstants: GlobalConstants,
    public readonly _defaultLanguageService: DefaultLanguageStringsService
  ) {
    // Assing empty array
    this.languageArray = [];
    this.language$ = new BehaviorSubject<{ [key: string]: string }>(undefined);
    this.errorSSOMessage$ = new BehaviorSubject<ErrorSSOSingleInterface>(
      undefined
    );
    this.msgNum = Number.parseInt(
      this._route.snapshot.queryParamMap.get("msgs")
    );
    if (!this.msgNum) this.msgNum = 1;
    else this.msgNum = this.msgNum > 4 ? 1 : this.msgNum;
  }

  public ngOnInit(): void {
    if (location.protocol === "http:" && location.hostname !== "localhost") {
      window.location.href = location.href.replace("http", "https");
    }

    // Get available languages
    this._languageService
      .getLanguages()
      .pipe(takeUntil(this.destroy$))
      .subscribe((language: any) => {
        // Assign llanguage data0
        this.languageArray = Object.values(language);
        if (
          typeof language === "undefined" ||
          Object.keys(language).length === 0
        ) {
          return;
        }

        let cultureCookie: string = this._cookieService.get("Culture");

        // get cookie value exist in languageArray
        const languageKey: any = this.languageArray.find(
          (item: any) => item.culture === cultureCookie
        );
        // Udating default language as cookie if cookie value exist in languageArray
        if (typeof languageKey === "undefined" || languageKey.length === 0) {
          this.languageArray.map((item: any) => {
            if (item.isDefault) {
              cultureCookie = item.culture;
            }
          });
        }
        // add language keys to translation service
        if (this._translate.getLangs().length < 1) {
          const langArr: string[] = this.languageArray.map(
            (item: any) => item.culture
          ); // Object.keys(language);
          this._translate.addLangs(langArr);
        }
        let languageFromUrl = this._route.snapshot.queryParamMap.get('l');
        if(!!languageFromUrl){
          this._translate.setDefaultLang(languageFromUrl);
          this._translate.use(languageFromUrl);
          this.selectedLanguage = languageFromUrl;
          this.language$.next(language);

        } else{
          // set default language to culture cookie language and use it
          this._translate.setDefaultLang(cultureCookie);
          this._translate.use(cultureCookie);
          this.selectedLanguage = cultureCookie;

          this.language$.next(language);

        }
      });

    this._siteLogoService
      .loadSiteLogo()
      .pipe(takeUntil(this.destroy$))
      .subscribe((href: string) => {
        if (!href) {
          return;
        }
        this.logoHref = href;
      });

    this.errorSSOMessage$.subscribe((errorMessage: ErrorSSOSingleInterface) => {
      if (!errorMessage) return;
      this.errorMessage = errorMessage;
    });

    if (!!this.msgNum) {
      this._siteSettingsService
        .loadErrorSSOSingleMessage(this.msgNum)
        .pipe(takeUntil(this.destroy$))
        .subscribe((errorSSOMessage: ErrorSSOSingleInterface) => {
          if (!errorSSOMessage) {
            return;
          }
          this.errorSSOMessage$.next(errorSSOMessage);
        });
    }

    // Close all open dialogs that may persist from the previous session.
    this.dialog.closeAll();
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public doneClick(): void {
    if (this._route.snapshot.queryParamMap.get("c") === "0") {
      return;
    }
  }

  private loginUuid(): void {
    let o = JSON.stringify({
      uuid: this._route.snapshot.queryParamMap.get("ut"),
    });
    this._authService
      .loginUuid(o, false)
      .pipe(skip(1), take(1))
      .subscribe((user: UserInterface) => {
        this.loadDefaultLanguageStrings();
        this.displayErrorContent = false;
        sessionStorage.setItem("isUserLoggedIn", "1");
        if (!user.tcAccept) {
          // this.endUserAgreementDialog();
        } else {
          // this.goToDashboard();
        }
      });
  }

  public refreshLanguages(language: string): void {
    if (localStorage.getItem(this._cookieName)) {
      this._languageService.getLanguages();
    }
    this.selectedLanguage = language;
  }

  public termsOfUseDialog(): void {
    this.dialog.open(TermsOfUseComponent, {
      height: "480px",
      width: "700px",
    });
  }

  public privacyPolicyDialog(): void {
    this.dialog.open(PrivacyPolicyComponent, {
      height: "480px",
      width: "700px",
    });
  }

  private loadDefaultLanguageStrings(): void {
    this._defaultLanguageService
      .loadDefaultLanguageStrings()
      .pipe()
      .subscribe((result: any) => {
        this._defaultLanguageService.setDefaultLanguageStrings(result);
      });
  }
}
